import { createAction } from '../../../utils/actionGenerator';

export const SIGN_IN = 'src/App/SIGN_IN'; // static action types
export const SIGN_OUT = 'src/App/SIGN_OUT';
export const SET_LOADER = 'src/App/SET_LOADER';
export const forUser = {
  signInDev: (profile, token, isCmsOnlyUser) => createAction(SIGN_IN, { profile, token, isCmsOnlyUser }),
  signOut: () => createAction(SIGN_OUT),
};
